import { Link } from "@mui/material";
import NextLink from "next/link";
import regexifyString from "regexify-string";

export default function hydrateNotification(notification) {
  // Uses Next's Link (client-side nav) rather than a plain href, since a full
  // page load would reset the contextual-back-navigation history tracking.
  // Falls back to plain text when the entity has no uuid to link to — the
  // activity feeds pass interaction payloads that aren't always hydrated.
  const createEntityLink = (text, href, index) =>
    href ? (
      <Link key={index} component={NextLink} href={href}>
        {text}
      </Link>
    ) : (
      <span key={index}>{text}</span>
    );

  const entityHref = (entity, section) =>
    entity?.uuid ? `/${section}/${entity.uuid}` : null;

  // Define the patterns and their replacements
  const patterns = {
    "{contact}": notification.contact ? notification.contact.name : "Unknown",
    "{float}": notification.float
      ? createEntityLink(notification.float.name, entityHref(notification.float, "floats"), 2)
      : "Unknown",
    "{submission}": notification.submission
      ? createEntityLink(
          notification.submission.name,
          entityHref(notification.submission, "submissions"),
          4
        )
      : "Unknown",
    "{candidate}": notification.candidate
      ? createEntityLink(
          notification.candidate.name,
          entityHref(notification.candidate, "candidates"),
          3
        )
      : "Unknown",
    "{duration}": notification.attributes?.duration ? notification.attributes.duration : "",
  };

  // Use regexifyString to replace patterns with Links
  return regexifyString({
    pattern: new RegExp(`(${Object.keys(patterns).join("|")})`, "g"),
    decorator: (match) => patterns[match],
    input: notification.body,
  });
}
